import {Controller} from 'stimulus';

export default class extends Controller {
  static targets = ['count', 'actionBar'];

  get checkboxes() {
    return new Array(...this.element.querySelectorAll('input[type=checkbox]'));
  }
}
